module.exports = __webpack_public_path__ + "static/media/PIJL_04.e60df4f6.png";